import { Box } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem';

const FilterContainer = styled(Box)`
  border-radius: ${themeGet('radii.default')};
  background: white;
  border: 1px solid ${themeGet('colors.greys.alto')};
  ${mediaQuery.minWidth.md} {
    border-radius: 0;
    border: none;
    border-bottom: none;
    background: none;
  }
`;

FilterContainer.displayName = 'FilterContainer';

export default FilterContainer;
